(function () {
  const WORKER_URL = 'https://lisbonvice.tomascapelamartins.workers.dev';

  function initCartQuoteRequest() {
    const root = document.querySelector('[data-cart-quote-root]');
    if (!root) return;

    const submitBtn = document.querySelector('[data-cart-quote-submit]');
    if (!submitBtn) return;

    if (root.dataset.cartQuoteInitialized === 'true') return;
    root.dataset.cartQuoteInitialized = 'true';

    const statusEl = root.querySelector('.cart-quote-request__status');
    const modal = document.getElementById('cart-quote-modal');
    const configEl = document.getElementById('cart-quote-status-config');

    let modalConfig = {
      success: {
      title: 'Your Lisbon plan is underway',
      description: 'We’ve received your request!<br> Keep an eye on your inbox, your quote should arrive within 24 hours.<br>Please check your spam folder too, just in case.<br><br> Need to add anything? Email us at <a href="mailto:hello@lisbonvice.com">hello@lisbonvice.com</a>.'
    },
    error: {
      title: 'Something got a bit messy',
      description: 'Your quote request could not be submitted. Please try again, or email us directly at hello@lisbonvice.com.'
    }
    };

    if (configEl) {
      try {
        modalConfig = JSON.parse(configEl.textContent);
      } catch (e) {
        console.warn('Could not parse cart quote modal config.', e);
      }
    }

    function getSubmitBtn() {
      return document.querySelector('[data-cart-quote-submit]');
    }

    function setLoading(isLoading) {
      const btn = getSubmitBtn();
      if (!btn) return;

      btn.disabled = isLoading;
      btn.classList.toggle('is-loading', isLoading);
      btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function setStatus(message) {
      if (statusEl) statusEl.textContent = message || '';
    }

    function clearErrors() {
      root.querySelectorAll('.cart-quote-request__error').forEach((el) => {
        el.textContent = '';
      });
    }

    function showError(name, message) {
      const el = root.querySelector(`[data-error-for="${name}"]`);
      if (el) el.textContent = message;
    }

    function openModal(type) {
      if (!modal) return;

      const title = modal.querySelector('.cart-quote-modal__title');
      const desc = modal.querySelector('.cart-quote-modal__desc');
      const cfg = modalConfig[type] || modalConfig.error;

      if (title) title.textContent = cfg.title || '';
      if (desc) desc.innerHTML = cfg.description || '';

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }

    if (modal) {
      modal.querySelectorAll('[data-cart-quote-close]').forEach((el) => {
        el.addEventListener('click', closeModal);
      });
    }

    function getField(name) {
      return root.querySelector(`[name="${name}"]`);
    }

    function extractText(el) {
      return el ? el.textContent.trim() : '';
    }

    function validate() {
      clearErrors();
      setStatus('');

      let ok = true;

      const name = getField('quote_name');
      const email = getField('quote_email');
      const people = getField('quote_people');
      const startDate = getField('quote_start_date');
      const endDate = getField('quote_end_date');
      const terms = getField('quote_terms');

      if (!name || !name.value.trim()) {
        ok = false;
        showError('quote_name', 'Name is required.');
      }

      if (!email || !email.value.trim()) {
        ok = false;
        showError('quote_email', 'Email is required.');
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        ok = false;
        showError('quote_email', 'Please enter a valid email address.');
      }

      if (!people || !people.value || Number(people.value) < 1) {
        ok = false;
        showError('quote_people', 'Please enter a valid number of people.');
      }

      if (!startDate || !startDate.value) {
        ok = false;
        showError('quote_start_date', 'Start date is required.');
      }

      if (!endDate || !endDate.value) {
        ok = false;
        showError('quote_end_date', 'End date is required.');
      }

      if (
        startDate &&
        endDate &&
        startDate.value &&
        endDate.value &&
        endDate.value < startDate.value
      ) {
        ok = false;
        showError('quote_end_date', 'End date must be after the start date.');
      }

      if (!terms || !terms.checked) {
        ok = false;
        showError('quote_terms', 'You must accept the terms.');
      }

      return ok;
    }

    function getCartItems() {
      return Array.from(document.querySelectorAll('.cart--item')).map((item, index) => {
        const title =
          item.querySelector('.cart--item--title a')?.textContent.trim() || '';

        let variant =
          item.querySelector('.cart--item--variant-name a')?.textContent.trim() ||
          item.querySelector('.cart--item--variant-name')?.textContent.trim() ||
          '';

        const qty =
          item.querySelector('input[id*="updates"]')?.value || '1';

        const propertyText = Array.from(
          item.querySelectorAll('.cart--item-properties, .cart--item-details')
        )
          .map((el) => el.textContent.replace(/\s+/g, ' ').trim())
          .filter(Boolean)
          .join(' ');

        if (!variant && propertyText) {
          const propertyMatch = propertyText.match(
            /(?:Package|Option|Variant|Type|Activity)\s*:\s*([^|]+)/i
          );

          if (propertyMatch && propertyMatch[1]) {
            variant = propertyMatch[1].trim();
          }
        }

        return {
          line: index + 1,
          title,
          packageLabel: variant,
          qty
        };
      });
    }

    function calculateNights(startDate, endDate) {
      if (!startDate || !endDate) return '';

      const start = new Date(startDate);
      const end = new Date(endDate);

      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return '';

      const diff = end.getTime() - start.getTime();
      const nights = Math.round(diff / (1000 * 60 * 60 * 24));

      return nights >= 0 ? nights : '';
    }

    function formatActivities(items) {
      if (!items.length) return '';

      return items
        .map((item) => {
          const variantText = item.packageLabel ? ` - ${item.packageLabel}` : '';
          return `${item.title}${variantText} x${item.qty}`;
        })
        .join('\n');
    }

    function buildPayload() {
      const turnstileField = root.querySelector('input[name="cf-turnstile-response"]');
      const honeypot = getField('company');

      const startDate = getField('quote_start_date')
        ? getField('quote_start_date').value.trim()
        : '';

      const endDate = getField('quote_end_date')
        ? getField('quote_end_date').value.trim()
        : '';

      const nameValue = getField('quote_name')
        ? getField('quote_name').value.trim()
        : '';

      const emailValue = getField('quote_email')
        ? getField('quote_email').value.trim()
        : '';

      const phoneValue = getField('quote_phone')
        ? getField('quote_phone').value.trim()
        : '';

      const peopleValue = getField('quote_people')
        ? getField('quote_people').value.trim()
        : '';

      const commentsValue = getField('quote_questions')
        ? getField('quote_questions').value.trim()
        : '';

      const cartItems = getCartItems();
      const activitiesValue = formatActivities(cartItems);

      return {
        name: nameValue,
        Name: nameValue,

        email: emailValue,
        phone: phoneValue,

        dateInicio: startDate,
        dataFim: endDate,
        DataInicio: startDate,
        DataFim: endDate,

        NrPessoas: peopleValue,
        'Nr de noites': calculateNights(startDate, endDate),

        comments: commentsValue,
        Comments: commentsValue,
        Questions: commentsValue,

        atividadesPacote: activitiesValue,

        'activities in': activitiesValue,
        'Activities in': activitiesValue,
        Activities: activitiesValue,

        activities: cartItems.map((item) => ({
          title: item.title,
          packageLabel: item.packageLabel || '',
          qty: item.qty
        })),

        extras: [],
        extrasText: '',

        note: document.querySelector('.cart--notes--textarea')
          ? document.querySelector('.cart--notes--textarea').value.trim()
          : '',

        cartSubtotal: extractText(document.querySelector('.cart--total-price')),

        company: honeypot ? honeypot.value : '',
        'cf-turnstile-response': turnstileField ? turnstileField.value : ''
      };
    }

    function resetForm() {
      root.querySelectorAll('input, textarea').forEach((field) => {
        if (field.name === 'quote_terms') return;
        if (field.name === 'company') return;
        if (field.name === 'cf-turnstile-response') return;
        if (field.type === 'hidden') return;

        field.value = '';
      });

      const terms = getField('quote_terms');
      if (terms) terms.checked = true;

      if (window.turnstile) {
        const widget = root.querySelector('.cf-turnstile');
        if (widget) {
          try {
            window.turnstile.reset(widget);
          } catch (e) {
            console.warn('Turnstile reset failed.', e);
          }
        }
      }
    }

    async function submitQuote() {
      setLoading(false);

      if (!validate()) {
        setStatus('Please fix the highlighted fields.');

        const firstError = root.querySelector('.cart-quote-request__error:not(:empty)');
        if (firstError) {
          firstError.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }

        return;
      }

      const payload = buildPayload();

      console.log('Cart quote payload:', payload);
      console.log('Cart quote worker URL:', WORKER_URL);

      if (payload.company) {
        setStatus('');
        setLoading(false);
        return;
      }

      if (!WORKER_URL) {
        console.error('Worker URL is missing.');
        setStatus('Worker URL is missing.');
        openModal('error');
        setLoading(false);
        return;
      }

      setLoading(true);
      setStatus('Sending...');

      try {
        const res = await fetch(WORKER_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const responseText = await res.text();

        console.log('Cart quote response status:', res.status);
        console.log('Cart quote response body:', responseText);

        if (!res.ok) {
          throw new Error(`Bad response: ${res.status}`);
        }

        setStatus('');
        openModal('success');
        resetForm();
      } catch (error) {
        console.error('Cart quote submit failed:', error);
        setStatus('');
        openModal('error');
      } finally {
        setLoading(false);
      }
    }

    submitBtn.addEventListener('click', submitQuote);
  }

  document.addEventListener('DOMContentLoaded', initCartQuoteRequest);
  document.addEventListener('shopify:section:load', initCartQuoteRequest);

  const observer = new MutationObserver(() => {
    initCartQuoteRequest();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();